import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h1>Page Not Found</h1>
            <p>The webpage you requested is not found.</p>
        </div>
    );
};

export default NotFound;